import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import SmoothScroll from "@/components/SmoothScroll";
import Nav from "@/components/Nav";
import ChatWidget from "@/components/ChatWidget";
import Home from "@/pages/Home";
import Product from "@/pages/Product";
import Quote from "@/pages/Quote";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function Chrome({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Nav />}
      {children}
      {!isAdmin && <ChatWidget />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <ScrollManager />
          <CartProvider>
            <Chrome>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/produit/:slug" element={<Product />} />
                <Route path="/devis" element={<Quote />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
              </Routes>
            </Chrome>
          </CartProvider>
          <Toaster position="bottom-right" theme="dark" />
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
